module.exports = __webpack_public_path__ + "static/media/BM_TrainingProgress.e0b20dee.svg";